module.exports = __webpack_public_path__ + "static/imp-c7396110772d3ff91ac89c37f932d105.jpg";